export default __webpack_public_path__ + "static/media/Vloerverwarming_-koeling.699287c0.png";